import { render } from "./LegalNotice.vue?vue&type=template&id=60e01dd4"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__